<div>
  <tix-communications-edit
    (enableBtn)="enableBtn($event)"
    (setEmailTemplates)="setEmailTemplates($event)"
    [id]="companyId"
    type="company"
  ></tix-communications-edit>

  <div class="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-8 justify-end">
    <button
      mat-button
      (click)="saveTemplates()"
      class="w-full sm:w-auto min-w-[160px] px-6 py-1.5 sm:py-1 bg-primary text-white font-medium"
      [ngClass]="[
        formInvalid || isLoading || isBtnDisabled
          ? 'cursor-not-allowed'
          : 'cursor-pointer',
        formInvalid || isLoading || isBtnDisabled
          ? 'hover:bg-gray-300 hover:text-gray-700 hover:opacity-50'
          : 'hover:bg-primary-700'
      ]"
      [disabled]="formInvalid || isLoading || isBtnDisabled"
    >
      <div *ngIf="!isLoading" class="flex items-center justify-center">
        <span class="material-icons-outlined mr-2 text-lg">save</span>
        <span>Save Changes</span>
      </div>
      <div *ngIf="isLoading" class="flex items-center justify-center space-x-2">
        <span class="mr-2" *tixBtnLoading="isLoading"></span>
        <span>Loading</span>
      </div>
    </button>
  </div>
</div>
